{
  "familyId": "TGL-GELD-BUDGET",
  "questions": [
    {
      "id": "TGL-GELD-BUDGET-001",
      "familyId": "TGL-GELD-BUDGET",
      "module": "TGL",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_budget",
      "questionType": "multiple_choice",
      "question": "Je hebt €20 zakgeld. Je koopt een boek voor €8,50 en een game voor €6,75. Hoeveel houd je over?",
      "options": [
        "€4,75",
        "€5,00",
        "€4,50",
        "€15,25"
      ],
      "correctAnswer": 0,
      "conceptId": "budget_pocket_money",
      "variantIndex": 1,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Budget beheren",
            "content": "Zakgeld: €20. Uitgaven: €8,50 + €6,75 = €15,25. Overhouden: €20 - €15,25 = €4,75."
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Strategie: tel eerst alle uitgaven op, dan trek je het totaal af van je budget. Stap 1: uitgaven: €8,50 + €6,75 = €15,25. Stap 2: overhouden: €20,00 − €15,25 = €4,75.",
        "distractorExplanations": {
          "0": "Correct! €20 − (€8,50 + €6,75) = €20 − €15,25 = €4,75.",
          "1": "Veelgemaakte fout: de centen verkeerd optellen. €8,50 + €6,75 = €15,25 (50 + 75 = 125 cent = €1,25). €20 − €15,25 = €4,75, niet €5,00.",
          "2": "Veelgemaakte fout: de centen verkeerd optellen of aftrekken. Controleer: €8,50 + €6,75 = €15,25. Dan: €20,00 − €15,25 = €4,75, niet €4,50.",
          "3": "Veelgemaakte fout: de uitgaven verwarren met wat je overhoudt. €15,25 is het totaal dat je uitgeeft. Je moet dit aftrekken van je budget: €20 − €15,25 = €4,75."
        }
      }
    },
    {
      "id": "TGL-GELD-BUDGET-002",
      "familyId": "TGL-GELD-BUDGET",
      "module": "TGL",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_budget",
      "questionType": "multiple_choice",
      "question": "Je wilt een fiets kopen van €150. Je hebt al €85 gespaard. Hoeveel moet je nog sparen?",
      "options": [
        "€65",
        "€75",
        "€55",
        "€235"
      ],
      "correctAnswer": 0,
      "conceptId": "budget_savings_goal",
      "variantIndex": 2,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Spaardoel berekenen",
            "content": "Doel: €150. Al gespaard: €85. Nog te sparen: €150 - €85 = €65."
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Strategie: nog te sparen = doel − al gespaard. Stap 1: doel: €150. Stap 2: al gespaard: €85. Stap 3: nog te sparen: €150 − €85 = €65.",
        "distractorExplanations": {
          "0": "Correct! €150 − €85 = €65.",
          "1": "Veelgemaakte fout: verkeerd aftrekken. €150 − €85 = €65, niet €75. Controleer: €85 + €65 = €150 ✓.",
          "2": "Veelgemaakte fout: verkeerd aftrekken. €150 − €85 = €65, niet €55. Controleer: €85 + €55 = €140 ≠ €150.",
          "3": "Veelgemaakte fout: optellen in plaats van aftrekken. €235 = €150 + €85. Maar je moet aftrekken: nog te sparen = doel − al gespaard = €150 − €85 = €65."
        }
      }
    },
    {
      "id": "TGL-GELD-BUDGET-003",
      "familyId": "TGL-GELD-BUDGET",
      "module": "TGL",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_budget",
      "questionType": "multiple_choice",
      "question": "Je budget voor de week is €15. Je hebt al €4,50 uitgegeven op maandag en €3,25 op dinsdag. Hoeveel kun je nog uitgeven?",
      "options": [
        "€7,25",
        "€7,75",
        "€6,75",
        "€22,75"
      ],
      "correctAnswer": 0,
      "conceptId": "budget_weekly",
      "variantIndex": 3,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Weekbudget bijhouden",
            "content": "Budget: €15. Uitgegeven: €4,50 + €3,25 = €7,75. Nog over: €15 - €7,75 = €7,25."
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Strategie: tel eerst alle uitgaven op, dan trek je het totaal af van je budget. Stap 1: uitgaven: €4,50 + €3,25 = €7,75. Stap 2: nog over: €15,00 − €7,75 = €7,25.",
        "distractorExplanations": {
          "0": "Correct! €15 − (€4,50 + €3,25) = €15 − €7,75 = €7,25.",
          "1": "Veelgemaakte fout: de uitgaven verwarren met wat je nog kunt uitgeven. €7,75 is het totaal dat je al hebt uitgegeven. Nog over: €15 − €7,75 = €7,25.",
          "2": "Veelgemaakte fout: de centen verkeerd optellen. €4,50 + €3,25 = €7,75 (50 + 25 = 75 cent). €15 − €7,75 = €7,25, niet €6,75.",
          "3": "Veelgemaakte fout: optellen in plaats van aftrekken. €22,75 = €15 + €7,75. Maar je moet aftrekken: nog over = budget − uitgegeven = €15 − €7,75 = €7,25."
        }
      }
    },
    {
      "id": "TGL-GELD-BUDGET-004",
      "familyId": "TGL-GELD-BUDGET",
      "module": "TGL",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_budget",
      "questionType": "multiple_choice",
      "question": "Je wilt 3 dingen kopen: een pen (€2,50), een schrift (€3,75) en een liniaal (€1,80). Je hebt €10. Heb je genoeg geld?",
      "options": [
        "ja, je houdt €1,95 over",
        "nee, je komt €1,95 tekort",
        "ja, je houdt €2,05 over",
        "precies genoeg"
      ],
      "correctAnswer": 0,
      "conceptId": "budget_check_enough",
      "variantIndex": 4,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Budget controleren",
            "content": "Totale kosten: €2,50 + €3,75 + €1,80 = €8,05. Je hebt: €10. Overhouden: €10 - €8,05 = €1,95. Ja, je hebt genoeg!"
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Strategie: tel eerst alle kosten op, dan vergelijk je met je budget. Stap 1: kosten: €2,50 + €3,75 + €1,80 = €8,05. Stap 2: budget: €10,00. Stap 3: €10,00 − €8,05 = €1,95 over. Je hebt genoeg!",
        "distractorExplanations": {
          "0": "Correct! Totaal: €8,05. Budget: €10. Over: €10 − €8,05 = €1,95.",
          "1": "Veelgemaakte fout: vergeten de kosten op te tellen vóór het vergelijken. €8,05 < €10, dus je hebt WEL genoeg. Je houdt €1,95 over.",
          "2": "Veelgemaakte fout: de centen verkeerd optellen. €2,50 + €3,75 + €1,80 = €8,05 (50 + 75 + 80 = 205 cent = €2,05). €10 − €8,05 = €1,95, niet €2,05.",
          "3": "Veelgemaakte fout: denken dat het precies genoeg is. €8,05 ≠ €10,00. Je houdt €1,95 over."
        }
      }
    },
    {
      "id": "TGL-GELD-BUDGET-005",
      "familyId": "TGL-GELD-BUDGET",
      "module": "TGL",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_budget",
      "questionType": "multiple_choice",
      "question": "Je krijgt €5 zakgeld per week. Je wilt iets kopen van €35. Hoeveel weken moet je sparen?",
      "options": [
        "7 weken",
        "6 weken",
        "8 weken",
        "30 weken"
      ],
      "correctAnswer": 0,
      "conceptId": "budget_weeks_to_save",
      "variantIndex": 5,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Sparenperiode berekenen",
            "content": "Doel: €35. Per week: €5. Aantal weken: €35 ÷ €5 = 7 weken."
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Strategie: deel het spaardoel door het bedrag per week. Stap 1: doel: €35. Stap 2: per week: €5. Stap 3: aantal weken: €35 ÷ €5 = 7 weken.",
        "distractorExplanations": {
          "0": "Correct! €35 ÷ €5 = 7 weken.",
          "1": "Veelgemaakte fout: er eentje naast zitten. 6 × €5 = €30, dat is €5 te weinig. Je hebt 7 weken nodig: 7 × €5 = €35 ✓.",
          "2": "Veelgemaakte fout: er eentje naast zitten. 8 × €5 = €40, dat is €5 te veel. Je hebt precies 7 weken nodig: 7 × €5 = €35 ✓.",
          "3": "Veelgemaakte fout: aftrekken in plaats van delen. €35 − €5 = €30 (niet 30 weken). Je moet delen: €35 ÷ €5 = 7 weken."
        }
      }
    },
    {
      "id": "TGL-GELD-BUDGET-006",
      "familyId": "TGL-GELD-BUDGET",
      "module": "TGL",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_budget",
      "questionType": "multiple_choice",
      "question": "Je hebt €50 voor je verjaardag gekregen. Je wilt €20 sparen en de rest uitgeven. Je koopt een t-shirt voor €15 en schoenen voor €22. Heb je genoeg?",
      "options": [
        "nee, je komt €7 tekort",
        "ja, je houdt €13 over",
        "ja, je houdt €7 over",
        "precies genoeg"
      ],
      "correctAnswer": 0,
      "conceptId": "budget_savings_first",
      "variantIndex": 6,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Eerst sparen, dan uitgeven",
            "content": "Totaal: €50. Sparen: €20. Te besteden: €50 - €20 = €30. Kosten: €15 + €22 = €37. Tekort: €37 - €30 = €7."
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Strategie: trek eerst het spaarbedrag af van je totaal, dan bereken je of je genoeg overhoudt. Stap 1: te besteden: €50 − €20 (sparen) = €30. Stap 2: kosten: €15 + €22 = €37. Stap 3: €37 > €30, dus je komt €37 − €30 = €7 tekort.",
        "distractorExplanations": {
          "0": "Correct! Te besteden: €30. Kosten: €37. Tekort: €7.",
          "1": "Veelgemaakte fout: vergeten dat je €20 wilt sparen. Je hebt €50, maar wilt €20 sparen. Te besteden: €50 − €20 = €30 (niet €50). Kosten: €37 > €30, dus tekort.",
          "2": "Veelgemaakte fout: het spaarbedrag vergeten. €50 − €20 = €30 te besteden (niet €50). Kosten: €37. Tekort: €37 − €30 = €7, niet €7 over.",
          "3": "Veelgemaakte fout: denken dat het precies genoeg is. Te besteden: €30. Kosten: €37. €37 ≠ €30, je komt €7 tekort."
        }
      }
    }
  ]
}